import { useFormatMenuItem } from "hooks/useFormatMenuItem";
import { Overlay, PanelMenuItem, useTitle } from "modules/common";
import { useOuterModules } from "modules/outerModules";
import { useSelector } from "react-redux";
import { GetOuterModuleRequest } from "services";
import { RootState } from "store";

const initialRequest: GetOuterModuleRequest = {
    page: 1,
    pageSize: 1000,
    search: null,
    isActive: null,
    isPublic: false,
};

export const ExternalModules = () => {
    useTitle("Dodatni moduli - eSavjetnik");
    const { data: outerModules } = useOuterModules(initialRequest);
    const previousLogin = useSelector((state: RootState) => state.signIn.user?.previousLogin);

    const menuItems: PanelMenuItem[] =
        outerModules?.items.map(item => ({
            label: item.name,
            link: item.url,
            description: item.description,
            newModule: Boolean(previousLogin) && new Date(item.created) > new Date(previousLogin!),
        })) ?? [];

    const formatMenuItem = useFormatMenuItem("external_modules");

    return (
        <Overlay
            containerClass={formatMenuItem}
            menuItems={menuItems}
            selectFirstMenuItemWhenAvailable
            titleBarProps={{
                fullScreenButton: true,
                newWindowButton: true,
            }}
            view={{
                title: "Dodatni moduli",
                source: item => item?.link ?? "",
            }}
        />
    );
};
